
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { WithAction, IActionStateProps } from '../withAction/WithAction';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ItemDefaultClickAction } from '../actions/defaultClick/DefaultClickAction';
import { displayNameFacet } from '../../facets/ItemFacets';
import { getCurrentItemKey } from '../../models/itemsScope/getCurrentItemKey';
import { haveSameParentItem } from '../../models/items/haveSameParentItem';
import { IReactChildrenProps } from '../../utilities/components/Props';

export interface IItemLinkProps {
  itemKey: string;
}

export const ItemLink: React.ComponentType<IItemLinkProps> = (props: IItemLinkProps & IReactChildrenProps): JSX.Element => {
  const {
    itemKey
  } = props;

  return (
    <WithItemCache>
      { ({ itemCache }: IItemCacheStateProps) => {
        let children: React.ReactNode;

        if (!props.children) {
          const displayName = itemCache.demandItemFacet(displayNameFacet, itemKey);

          children = displayName;
        } else {
          children = props.children;
        }

        // It is possible that the current item is actually a set, rather than just a folder.
        // In that case, the action should only be available if the 'parent' item does not match.
        const currentItemKey = getCurrentItemKey(itemCache);

        const action = !haveSameParentItem(itemCache, {
          itemKey1: itemKey,
          itemKey2: currentItemKey
        }) ? (
            <ItemDefaultClickAction itemKey={ itemKey } />
          ) : (
            null
          );

        return (
          <WithAction
            action={ action }
          >
            { ({ isAvailable, execute }: IActionStateProps) => {
              const onClick = isAvailable ? () => {
                execute().catch(() => {
                  // Ignore errors.
                });
              } : undefined;

              return onClick ? (
                <Link onClick={ onClick }>{ children }</Link>
              ) : (
                  <span>{ children }</span>
                );
            } }
          </WithAction>
        );
      } }
    </WithItemCache>
  );
};
